import { useSyncExternalStore } from 'react'
import {
  type Bilan,
  drainerFile,
  type ElementFile,
  listerFile,
  type OptionsDrainage,
} from './file-envoi'
import { marquerOccupee } from './occupation'

// État de la file d'envoi partagé par les pages (pages en attente sur ce téléphone, dernier
// bilan), relu après chaque mise en file et chaque passage du draineur.

type Etat = { elements: ElementFile[]; bilan: Bilan | null; enCours: boolean }

let etat: Etat = { elements: [], bilan: null, enCours: false }
const abonnes = new Set<() => void>()
const surLivraisons = new Set<(envois: string[]) => void>()

/** Prévenu quand un passage (quel qu'il soit) a livré au moins un envoi. */
export function surLivraison(f: (envois: string[]) => void): () => void {
  surLivraisons.add(f)
  return () => void surLivraisons.delete(f)
}

function publier(suite: Partial<Etat>) {
  etat = { ...etat, ...suite }
  // La file non vide retient un rechargement de mise à jour (jusqu'au plafond : octets sûrs).
  marquerOccupee('file', etat.elements.length > 0)
  for (const a of [...abonnes]) a()
}

export async function relireFile(): Promise<void> {
  publier({ elements: await listerFile() })
}

/** Lance un passage du draineur et publie son bilan ; ne lève jamais. */
export async function drainer(o: OptionsDrainage = {}): Promise<Bilan> {
  publier({ enCours: true })
  try {
    const bilan = await drainerFile(o)
    publier({ bilan, elements: await listerFile(), enCours: false })
    if (bilan.envoisLivres.length > 0) for (const f of [...surLivraisons]) f(bilan.envoisLivres)
    return bilan
  } catch {
    publier({ enCours: false })
    return {
      livrees: 0,
      gardees: 0,
      abandonnees: 0,
      parRaison: {},
      connexionPerdue: false,
      envoisLivres: [],
    }
  }
}

export function useEtatFile(): Etat {
  return useSyncExternalStore(
    (a) => {
      abonnes.add(a)
      return () => abonnes.delete(a)
    },
    () => etat,
  )
}
